import "bootstrap/dist/css/bootstrap.min.css";
import "./Navbar.css";
import React, { useState, useRef, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Brand from "../Assets/Brand.webp";

const NavBarComponent = () => {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);

  const handleNavbarToggle = () => {
    setExpanded(!expanded);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expanded &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target)
      ) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [expanded]);

  const scrollToTop = () => {
    setExpanded(false);
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  };

  return (
    <>
      <Navbar
        ref={navbarRef}
        expand="lg"
        className="navigation-bar  justify-content-between"
        expanded={expanded}
        collapseOnSelect
      >
        <Navbar.Brand as={NavLink} to="/" className="brand-logo">
          <img
            src={Brand}
            alt="VR Global Consulting ISO Certification Logo"
            title="VR Global Consulting - ISO Certification Experts | ISO 9001, ISO 14001, ISO 45001, ISO 22000, ISO 27001"
            className="img-fluid"
            width="230"
            height="60"
            fetchPriority="high"
            decoding="async"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={handleNavbarToggle}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/"
              onClick={scrollToTop}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/About-us"
              onClick={scrollToTop}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/Services"
              onClick={scrollToTop}
            >
              Our Services
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/iso-9001-training-courses"
              onClick={scrollToTop}
            >
              ISO Training
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/BlogLanding"
              onClick={scrollToTop}
            >
              Blogs
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/ShowCase"
              onClick={scrollToTop}
            >
              Showcase
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              className="nav-links"
              to="/Contact"
              onClick={scrollToTop}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavBarComponent;
